var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C5.17267 20 4.5 19.3273 4.5 18.5V5.5C4.5 4.67267 5.17267 4 6 4H16.03C16.4247 4 16.796 4.15133 17.078 4.426L19.0473 6.348C19.3347 6.62867 19.5 7.02 19.5 7.422V18.5C19.5 19.3273 18.8273 20 18 20H6ZM6 5C5.724 5 5.5 5.224 5.5 5.5V18.5C5.5 18.776 5.724 19 6 19H18C18.276 19 18.5 18.776 18.5 18.5V7.422C18.5 7.288 18.4447 7.15733 18.3487 7.064L16.3793 5.142C16.2853 5.05067 16.162 5 16.0307 5H6Z",
    fill: "#D337F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03027 10C7.75427 10 7.53027 9.776 7.53027 9.5C7.53027 9.224 7.75427 9 8.03027 9H16.0303C16.3063 9 16.5303 9.224 16.5303 9.5C16.5303 9.776 16.3056 10 16.0303 10H8.03027Z",
    fill: "#D337F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03027 13C7.75427 13 7.53027 12.776 7.53027 12.5C7.53027 12.224 7.75427 12 8.03027 12H16.0303C16.3063 12 16.5303 12.224 16.5303 12.5C16.5303 12.776 16.3063 13 16.0303 13H8.03027Z",
    fill: "#D337F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03027 16C7.75427 16 7.53027 15.776 7.53027 15.5C7.53027 15.224 7.75427 15 8.03027 15H12.0303C12.3056 15 12.5303 15.224 12.5303 15.5C12.5303 15.776 12.3056 16 12.0303 16H8.03027Z",
    fill: "#D337F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.30617525.svg";
export { ForwardRef as ReactComponent };